import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';
import Wrapper from 'src/components/common/wrapper';
import SigninForm from 'src/components/form/SigninForm';

const SigninPage = () => {
  return (
    <Wrapper width="xs">
      <Helmet>
        <title>SMUVE </title>
      </Helmet>
      <Typography sx={{ mb: 3 }} variant="h4" color={'primary'}>
        Sign in to SMUVE
      </Typography>
      <SigninForm />
    </Wrapper>
  );
};

export default SigninPage;
